
export default class Rooms {

	static getHolderSelectors = () => ['.rooms-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		const sliderElement = holderElement.querySelector('.splide');
		if (sliderElement) {
			const slider = new Splide(sliderElement, {
				type: 'loop',
				perPage: 2,
				perMove: 1,
				gap: '2rem',
				pagination: false,
				arrows: false,
				breakpoints: {
					768: {
						perPage: 1,
					},
					960: {
						perPage: 2,
					}
				}
			});
			slider.mount();

			const sliderControls = holderElement.querySelectorAll('[data-slider-control]');
			sliderControls.forEach(sliderControl => {
				sliderControl.addEventListener('click', () => {
					slider.go(sliderControl.dataset.sliderControl);
				});
			});



		}

	}

}
